
import { ActionButtons } from '../../dashboard/subContent/buttonsContainer/ActionButtons'
import { SearchContainer } from '../../dashboard/subContent/searchContainer/SearchContainer'
import { UsuariosDataTable } from '../../dashboard/subContent/dataTable/UsuariosDataTable'
import { mockUsuarios } from '../../../assets/UsuariosMocks'
import './tpaTraining.css'
import { Link } from 'react-router-dom'
import { InputCheckBox } from '../../dashboard/subContent/CheckBox/InputCheckBox'
import useSearchMember from '../../../hooks/fetchUsers'
import { TrainingStatesMapping } from './TrainingStateModel'
import { tpaTrainingSearchSchema } from './tpaTrainingSearchSchema'
import { useEffect, useState } from 'react'
import { tpaActionsPack } from './tpaActionsOnUserMock'
import { TpaTrainingTable } from './TpaTrainingTable'
import { param } from 'jquery'



export const TpaTraining = () => {

  useEffect(() => {
    document.title = 'TPA® Admin - Miembros TPA Training'
  }, [])

  const URL = 'TPATraining'

  const { renderUsers, handleObject, loading, customData } = useSearchMember(URL)

  

  const [HideReached, setHideReached] = useState(true)

  const HideReachedValue = (params) => {
       setHideReached(params)
  };


  const [defaultCheckBoxPageSize, setDefaultCheckBoxPageSize] = useState(null)
  
    const onInputCheckBoxPageSize = (PageSize) => {
         setDefaultCheckBoxPageSize(PageSize)
    };

  return (
    <>

<div className='m-4'>

          <div className='formation-card-header'>
            <div className='formation-container-actions card-tools'>

            
              <div className="title-decoration">
                <div class="accent-line"></div>
                <h1 className='pull-left formation-page-title mb-0'>TPA Training</h1>
              </div>

            </div>
          </div>
        </div>


      <ActionButtons
        dropdown={false}
        usersData={renderUsers}
        handleObject={handleObject}
      />

      <div className="row mt-3 me-0">
        <div className="col-12 col-md-9"></div>

        <div className="col-12 col-md-3 d-flex justify-content-center gap-2">
          <Link className="btn btn-calendar" target="_blank" to="https://bookandcome.com/app/#/turnos">
            <span className="fa fa-calendar"></span>
            Agenda
          </Link>
          <Link className="btn btn-new-student" target="_blank" to="https://bookandcome.com/app/#/cliente/add">
            <span className="fa fa-plus"></span>
            Alumno
          </Link>
        </div>
      </div>

      <SearchContainer
        handleObject={handleObject}
        searchSchema={tpaTrainingSearchSchema}
      />

      <InputCheckBox
        handleObject={handleObject}
        HideReachedValue={HideReachedValue}
        
      />

      <TpaTrainingTable
        
        actionsPack={tpaActionsPack}
        stateModel={TrainingStatesMapping}
        currentPagination={customData.current}
        usersData={renderUsers}
        handleObject={handleObject}
        loading={loading}
        memberShip={false} //👉 activa el modal de informacion del miembro
        alert={true} //👉 activa el modal de alerta de acciones 
        HideReached={HideReached}
        onInputCheckBoxPageSize={onInputCheckBoxPageSize}
      />

    </>
  )
}
